import React, { Component, PropTypes } from 'react';
import './Eevee.scss';

class Eevee extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="eevee">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Eevee;



/** WEBPACK FOOTER **
 ** ./source/133-eevee/Eevee.js
 **/